import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { categoryRecipes } from '../../data/recipes';
import { ArticleService } from '../../services/api.services';
import pic1 from '../../assets/images/pic-1.webp';
import pic5 from '../../assets/images/pic-5.webp';
import './TermsConditionsPage.css';

const TermsConditionsPage: React.FC = () => {
  const [currentDate, setCurrentDate] = useState('');
  const [dynamicRecipes, setDynamicRecipes] = useState<any[]>([]);

  useEffect(() => {
    // Generate real-time date for the "Last updated" section
    const date = new Date().toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    setCurrentDate(date);

    // Fetch dynamic recipes for the sidebar
    ArticleService.getAll({ perPage: 8 })
      .then(res => {
         if (res.success && res.data && res.data.length > 0) {
            setDynamicRecipes(res.data);
         }
      })
      .catch(console.error);
  }, []);

  // Use dynamic recipes if available, else fallback to static data
  const sourceRecipes = dynamicRecipes.length > 0 ? dynamicRecipes : categoryRecipes.slice(0, 8);
  const trendingRecipes = sourceRecipes.slice(0, 4);
  const recentRecipes = sourceRecipes.slice(4, 8);

  // Normalise recipe object for rendering
  const renderRecipeItem = (recipe: any) => {
    const isDynamic = 'image' in recipe;
    const img = isDynamic ? (recipe.image || pic1) : recipe.img;
    const title = recipe.title;
    const id = isDynamic ? (recipe.slug || recipe.id) : recipe.id;

    return (
      <div className="widget-recipe-item" key={recipe.id}>
        <Link to={`/blog-details/${id}`} className="widget-recipe-img-link">
          <img src={img} alt={title} className="widget-recipe-img" />
        </Link>
        <div className="widget-recipe-info">
          <h4 className="widget-recipe-title">
            <Link to={`/blog-details/${id}`}>{title}</Link>
          </h4>
          <div className="widget-recipe-meta">
            <span className="stars">★★★★★</span>
            <span className="time">15 MINS</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <main className="terms-page-v2">
      <div className="terms-container-v2">
        {/* Main Content Area */}
        <div className="terms-main-content">
          <div className="terms-header-v2">
            <h1 className="terms-title-v2">TERMS AND CONDITIONS</h1>
            <p className="terms-updated-v2">LAST UPDATED ON {currentDate.toUpperCase()}</p>
          </div>

          <div className="terms-body">
            <p className="terms-intro">
              Welcome to Famous Indian Recipes! These terms and conditions outline the rules and regulations for the use of our website.
              By accessing this website we assume you accept these terms and conditions. Do not continue to use Famous Indian Recipes if you do not agree to take all of the terms and conditions stated on this page.
            </p>

            <h2 className="terms-heading">INTELLECTUAL PROPERTY RIGHTS</h2>
            <p>
              Unless otherwise stated, Famous Indian Recipes and/or its licensors own the intellectual property rights for all material on Famous Indian Recipes. All intellectual property rights are reserved. You may access this from Famous Indian Recipes for your own personal use subjected to restrictions set in these terms and conditions.
            </p>
            <p>You must not:</p>
            <ul className="terms-list">
              <li>Republish material from Famous Indian Recipes without explicit written permission.</li>
              <li>Sell, rent or sub-license material from Famous Indian Recipes.</li>
              <li>Reproduce, duplicate or copy material from Famous Indian Recipes.</li>
              <li>Redistribute content from Famous Indian Recipes.</li>
            </ul>

            <h2 className="terms-heading">USER GENERATED CONTENT</h2>
            <p>
              Parts of this website offer an opportunity for users to post and exchange opinions and information (such as recipes or comments). Famous Indian Recipes does not filter, edit, publish or review Comments prior to their presence on the website.
            </p>
            <p>
              Comments do not reflect the views and opinions of Famous Indian Recipes, its agents and/or affiliates. Comments reflect the views and opinions of the person who post their views and opinions. To the extent permitted by applicable laws, Famous Indian Recipes shall not be liable for the Comments or for any liability, damages or expenses caused and/or suffered as a result of any use of and/or posting of and/or appearance of the Comments on this website.
            </p>

            <h2 className="terms-heading">LIMITATION OF LIABILITY</h2>
            <p>
              In no event shall Famous Indian Recipes, nor any of its officers, directors, and employees, be held liable for anything arising out of or in any way connected with your use of this website whether such liability is under contract. Famous Indian Recipes, including its officers, directors, and employees shall not be held liable for any indirect, consequential, or special liability arising out of or in any way related to your use of this website.
            </p>

            <h2 className="terms-heading">RECIPE OUTCOMES & ALLERGIES</h2>
            <p>
              The recipes provided on this website are for general information and entertainment purposes. We cannot guarantee the exact outcome of a recipe due to variations in ingredients, equipment, or cooking skill. It is your responsibility to determine the value and quality of any recipe or instructions provided for food preparation and to determine the nutritional value, if any, and safety of the preparation instructions.
            </p>
            <p>
              Furthermore, Famous Indian Recipes is not responsible for any allergic reactions or health issues that may occur. Please thoroughly review ingredients to ensure they comply with your personal dietary restrictions or allergies before consumption.
            </p>

            <h2 className="terms-heading">GOVERNING LAW</h2>
            <p>
              These Terms will be governed by and interpreted in accordance with the laws of the jurisdiction where Famous Indian Recipes is based, and you submit to the non-exclusive jurisdiction of the state and federal courts located there for the resolution of any disputes.
            </p>

            <h2 className="terms-heading">CHANGES TO THESE TERMS</h2>
            <p>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. By continuing to access or use our website after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the website.
            </p>
          </div>
        </div>

        {/* Right Sidebar */}
        <aside className="terms-sidebar">
          {/* About Me Widget */}
          <div className="sidebar-widget about-widget">
            <img src={pic5} alt="Loganayaki Thamilselvan" className="sidebar-author-img" />
            <p className="sidebar-author-bio">
              Hi, I'm Loganayaki Thamilselvan. Food stylist & photographer. Loves nature and healthy food, and good coffee.
            </p>
            <Link to="/about" className="sidebar-read-more">Read more</Link>
          </div>

          {/* Social Icons Widget */}
          <div className="sidebar-widget social-widget">
            <div className="social-icons">
               <a href="#fb" aria-label="Facebook">
                 <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" /></svg>
               </a>
               <a href="#ig" aria-label="Instagram">
                 <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5" ry="5" /><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" /><line x1="17.5" y1="6.5" x2="17.51" y2="6.5" /></svg>
               </a>
               <a href="#tw" aria-label="Twitter">
                 <svg viewBox="0 0 24 24" fill="currentColor"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" /></svg>
               </a>
            </div>
          </div>

          {/* Trending Recipes Widget */}
          <div className="sidebar-widget recipes-widget">
            <h3 className="widget-title">CURRENTLY TRENDING</h3>
            <div className="widget-recipe-list">
              {trendingRecipes.map(renderRecipeItem)}
            </div>
          </div>

          {/* Recent Recipes Widget */}
          <div className="sidebar-widget recipes-widget">
            <h3 className="widget-title">RECENT RECIPES</h3>
            <div className="widget-recipe-list">
              {recentRecipes.map(renderRecipeItem)}
            </div>
          </div>
        </aside>
      </div>
    </main>
  );
};

export default TermsConditionsPage;
